// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  width: 100%;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.navbar .logo {
  display: flex;
  align-items: center;
  font-weight: bold;
  gap: 10px;
  cursor: pointer;
}
.navbar .icons {
  display: flex;
  align-items: center;
  gap: 20px;
}
@media screen and (max-width: 480px) {
  .navbar .icons .icon {
    display: none;
  }
}
.navbar .icons .notification {
  position: relative;
}
.navbar .icons .notification span {
  position: absolute;
  width: 16px;
  height: 16px;
  background-color: red;
  color: white;
  border-radius: 50%;
  top: -10px;
  right: -10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.navbar .icons .user {
  display: flex;
  align-items: center;
  gap: 10px;
}
.navbar .icons .user img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/navbar/navbar.scss","webpack://./src/styles/responsive.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFJ;ACXE;EDeE;IAEI,aAAA;EAFN;AACF;AAKI;EACE,kBAAA;AAHN;AAKM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAHR;AAOI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AALN;AAOM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AALR","sourcesContent":["@import \"../../styles/responsive.scss\";\n\n.navbar {\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .logo {\n    display: flex;\n    align-items: center;\n    font-weight: bold;\n    gap: 10px;\n    cursor: pointer;\n  }\n\n  .icons {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n\n    .icon {\n      @include sm {\n        display: none;\n      }\n    }\n\n    .notification {\n      position: relative;\n\n      span {\n        position: absolute;\n        width: 16px;\n        height: 16px;\n        background-color: red;\n        color: white;\n        border-radius: 50%;\n        top: -10px;\n        right: -10px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 12px;\n      }\n    }\n\n    .user {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n\n      img {\n        width: 26px;\n        height: 26px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n    }\n  }\n}\n","$sm: 480px;\n$md: 768px;\n$lg: 1024px;\n$xl: 1200px;\n$xxl: 1440px;\n\n@mixin sm {\n  @media screen and (max-width: $sm) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media screen and (max-width: $md) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media screen and (max-width: $lg) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media screen and (max-width: $xl) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media screen and (max-width: $xxl) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
